import axios from 'axios'

const state = {
    pageSpinner: false,
    fixedFooter: false,
    setRaeValue: true, // REMOVE AFTER REFER AND EARN
    itemsCountry: null,
    postedItem: null,
    postedItems: null,
    likedItems: null,
    displayLikes: null,
    sellerItems: null,
    relatedItems: null,
    setCountries: null,
    setCategories: null,
    setSubCategories: null,
    setConditions: null,
}

const getters = {
    pageSpinner (state) {
        return state.pageSpinner
    },
    fixedFooter (state) {
        return state.fixedFooter
    },
    itemsCountry (state) {
        return state.itemsCountry
    },
    postedItem (state) {
        return state.postedItem
    },
    postedItems (state) {
        return state.postedItems
    },
    likedItems (state) {
        return state.likedItems
    },
    displayLikes (state) {
        return state.displayLikes
    },
    sellerItems (state) {
        return state.sellerItems
    },
    relatedItems (state) {
        return state.relatedItems
    },
    setCountries (state) {
        return state.setCountries
    },
    setCategories (state) {
        return state.setCategories
    },
    setSubCategories (state) {
        return state.setSubCategories
    },
    setConditions (state) {
        return state.setConditions
    },
    setRaeValue (state) { // REMOVE AFTER REFER AND EARN
        return state.setRaeValue
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {  
    async setLoader({ commit }, payload) {
        return commit('PAGE_SPINNER', payload)
    },
    
    async shoppingCountry({ commit, getters }) {
        // fetch the users local or intl. shopping country of choice
        let country = ''
        if(getters.authenticated && getters.user) {
            // local shopping
            country = getters.user.alphaCode
            // intl shopping
            if(getters.user.intlShpAlphaCode){
                country = getters.user.intlShpAlphaCode !== getters.user.alphaCode 
                    ? getters.user.intlShpAlphaCode 
                    : country
            }
        }
        return commit('ITEMS_COUNTRY', country)
    },

    async listPostedItem({ commit, getters }, itemId) {
        let viewerId = null
        if(getters.authenticated){ viewerId = getters.user._id }
        let response = await axios.get(`/items/fetchPostedItem/${itemId}/${viewerId}`)
        commit('POSTED_ITEM', null)
        if(response.data !== null){
            commit('POSTED_ITEM', response.data.result)
        }
        return response.data
    },
    
    async theSellerItems({ commit }, sellerId) {
        commit('SELLER_ITEMS', null)
        let response = await axios.post('/listItem/sellerItems', {sellerId})
        if(response.data !== null){
            return commit('SELLER_ITEMS', response.data.result)
        }
    },

    async theRelatedItems({ commit }, category) {
        commit('RELATED_ITEMS', null)
        let response = await axios.post('/listItem/relatedItems', {category})
        if(response.data !== null){
            return commit('RELATED_ITEMS', response.data.result)
        }
    },
    
    async myLikedItemsArray({ commit }, items) { 
        commit('LIKED_ITEMS', items)
    },

    async displayMyLikedItems({ commit }, userObj) { // runs when user opens the likes page
        commit('DISPLAY_LIKES', null)
        let response = await axios.post('/likes/displayLikedItems', userObj)
        if(response.data !== null){
            return commit('DISPLAY_LIKES', response.data.result)
        }
    },

    async fetchMyLikedItems({ dispatch }, userObj) { // runs when users signIn is successful
        let response = await axios.post('/likes/allMyLikedItems', userObj)
        if(response.data !== null){
            return dispatch('myLikedItemsArray', response.data.result)
        }
    },

    async likeItem({ dispatch, getters }, likeObj) {
        // get the current content of state.likedItems then concatinate this new values to it
        let occupantArr = getters.likedItems === null ? [] : getters.likedItems
        let incomingArr = likeObj.itemId
        let combinedArr = occupantArr.concat(incomingArr)
        dispatch('myLikedItemsArray', combinedArr)
        await axios.post('/likes/addLikedItem', likeObj)
    },
    
    async dislikeItem({ dispatch, commit, getters }, dislikeObj) {
        // remove the item from my likes arr by filtering it out
        let occupantArr = getters.likedItems
        let filteredLikesArr = occupantArr.filter(item => item !== dislikeObj.itemId)
        dispatch('myLikedItemsArray', filteredLikesArr)
        await axios.post('/likes/removeLikedItem', dislikeObj)
        // empty my likes getters completely. then refetch them by running fetchMyLikedItems
        if(filteredLikesArr.length == 0){
            commit('LIKED_ITEMS', null)
            dispatch('fetchMyLikedItems', dislikeObj)
        }
    },

    async footerFixed({ commit }, val) { 
        if(val == '') { val = false }
        return commit('FIXED_FOOTER', val)
    },

    async sendBuyersNegotiation({ _ }, itemObj) { 
        let response = await axios.post('/cart/negotiateItem', itemObj)
        return response.data
    },
    
    async sendBuyersEnquiry({ _ }, itemObj) { 
        let response = await axios.post('/cart/enquireItem', itemObj)
        return response.data
    },

    async fetchConditions({ commit }) {
        let response = await axios.get('/counts/conditions')
        return commit('SET_CONDITIONS', response.data.result)
    },
    
    async fetchCategories({ commit }) {
        let response = await axios.get('/counts/categories')
        return commit('SET_CATEGORIES', response.data.result)
    },
    async fetchSubCategories({ commit }, subCategoryObj) {
        let response = await axios.get(`/counts/subCategories/${subCategoryObj.categoryName}`)
        commit('SET_SUB_CATEGORIES', null)
        return commit('SET_SUB_CATEGORIES', response.data.result)
    },
    async fetchShippingMethodFeesAction({ _ }, subCategoryObj) {
        let response = await axios.get(`/counts/shippingMethodFees/${subCategoryObj.categoryName}/${subCategoryObj.subCategoryName}`)
        return response.data
    },

    async fetchCountries({ commit }, purpose) {
        // purpose can also be 'international' used to fetch only countries with items for intlShopping 
        if(!purpose) { purpose = 'signup' }
        let response = await axios.get(`/location/countries/${purpose}`)
        return commit('SET_COUNTRIES', response.data.result)
    },

    async fetchPaymentLink({ _ }, paymentObj) {
        let response = await axios.post('/order-payments/payment-details', paymentObj)
        return response.data
    },
    
    async completePayment({ _ }, paymentObj) {
        let response = await axios.post('/order-payments/complete-order-payment', paymentObj)
        return response.data
    },

    // REMOVE AFTER REFER AND EARN 
    async disableRaePopup({ commit }) { 
        commit('RAE_VALUE', false)
    },
    
}

const mutations = {
    PAGE_SPINNER: (state, pageSpinner) => (state.pageSpinner = pageSpinner),
    ITEMS_COUNTRY: (state, itemsCountry) => (state.itemsCountry = itemsCountry),
    POSTED_ITEM: (state, postedItem) => (state.postedItem = postedItem),
    POSTED_ITEMS: (state, postedItems) => (state.postedItems = postedItems),
    LIKED_ITEMS: (state, likedItems) => (state.likedItems = likedItems),
    DISPLAY_LIKES: (state, displayLikes) => (state.displayLikes = displayLikes),
    SELLER_ITEMS: (state, sellerItems) => (state.sellerItems = sellerItems),
    RELATED_ITEMS: (state, relatedItems) => (state.relatedItems = relatedItems),
    FIXED_FOOTER: (state, fixedFooter) => (state.fixedFooter = fixedFooter),
    SET_COUNTRIES: (state, setCountries) => (state.setCountries = setCountries),
    SET_CONDITIONS: (state, setConditions) => (state.setConditions = setConditions),
    SET_CATEGORIES: (state, setCategories) => (state.setCategories = setCategories),
    SET_SUB_CATEGORIES: (state, setSubCategories) => (state.setSubCategories = setSubCategories),
    RAE_VALUE: (state, setRaeValue) => (state.setRaeValue = setRaeValue),
}

export default {
    state,
    getters,
    actions,
    mutations
}